import {  Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import "./style.css";
import NoArticlesImg from "../../../../../assets/img/accounts-drawer-no-articles.svg";
import {
  getAccountArticles,
  updateAccountingLine
} from "../../../../../store/actions/precog/accountingLines";
import { useDispatch, useSelector } from "react-redux";
import ArticlesFilters from "./articlesFilters";
import InfiniteScroll from "react-infinite-scroller";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Checkbox } from "@ts-digital/vrc";
import numeral from "numeral";
import Scrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import ModalNature from "../modalNature";

const Option = Select.Option;

const ArticlesTab = ({
  invoiceId, contoId, contiNew, setModifiedDetail, setExpandedRow, setPage, expandedRow, page, loadMoreItems, refCurrency, isMonoRegime, setIsDrawerToClose, contoSelected, setContoSelected
}) => {

  const dispatch = useDispatch();
  // const [contoToMove, setContoToMove] = useState(contoId);
  const [selectedResults, setSelectedResults] = useState([]);
  // const [hasChildren, setHasChildren] = useState(false);
  const [fieldToChange, setFieldToChange] = useState(null);
  const [checkedAll, setCheckedAll] = useState(false);
  const [drawerNature, setDrawerNature] = useState(false);
  const [accountsList, setAccountsList] = useState([]);
  const [currentExemption, setCurrentExemption] = useState(null);

  const accounts = useSelector(state => state.precog.detailAccounts.data?.accountingLinesByCodeApiResList);
  const accountArticles = useSelector(state => state.precog.accountArticles.data);
  const accountArticlesStatus = useSelector(state => state.precog.accountArticles.status);
  const patchArticleStatus = useSelector(state => state.precog.accountingLine?.isLoading);
  const exemptionNatures = useSelector(state => state.precog.vat.exemptionNatures.list);

  const containerArticlesRef = useRef();

  useEffect(() => {
    if (!contoId) return;
    setContoSelected(contoId);
  }, []);

  useEffect(() => {  
    if (!contoSelected) return;
    const currentConto = accounts.find(el => el.uuid === contoSelected);
    if (currentConto?.hasChildren && expandedRow) {
      if (contoSelected !== expandedRow[0]) {
        dispatch(getAccountArticles(invoiceId, contoSelected));
        setPage(page +1);
      }
      // setHasChildren(currentConto.hasChildren);
    } else {
      dispatch(getAccountArticles(invoiceId, contoSelected));
      // setHasChildren(false);
    }
  }, [contoSelected]);

  useEffect(() => {
    if (!fieldToChange) return; 
    if (fieldToChange?.hasOwnProperty("accountCode")) {
      const currentCode = contiNew.find(el => el.uuid === fieldToChange.accountCode).accountCode;
      const toChange = { accountCode: currentCode, destinationGroupId: fieldToChange.accountCode, parentId: currentCode, totalAmountForCO1: 0 };
      setModifiedDetail({ accountingLine: selectedResults, modifiedData: toChange, isArticleDrawer: true, contoSelected: fieldToChange.accountCode });
      setFieldToChange(null);
    } else {
      dispatch(updateAccountingLine(
        invoiceId, selectedResults, fieldToChange
      )).then(res => {
        
        setFieldToChange(null);
      });
    }
  }, [fieldToChange]);

  useEffect(() => {
    if (!contiNew) return;
    const arrayAccounts = [];
    contiNew.forEach((el, index) => {
      if (el.isPosting) {
        arrayAccounts.push(<Option
          key={`contiNew_${index}`}
          value={el.uuid}
        >
          <div className="articles-accordion-select-item">
            {el.accountDesc}
          </div>
        </Option>);
      }
    });
    setAccountsList(arrayAccounts);
  }, [contiNew]);

  useEffect(() => {
    if (!containerArticlesRef.current) return undefined;
    let ps = new Scrollbar(containerArticlesRef.current, {wheelPropagation: true});
    return () => {
      if (ps) {
        ps.destroy();
        ps = null;
      }
    };
  }, [containerArticlesRef?.current]);

  const loader = (
    <div
      style={{ textAlign: "center", fontSize: "32px", color: "#0090d1" }}
      key={Math.random()}
    >
      <FontAwesomeIcon icon={["far", "circle-notch"]} spin />
    </div>
  );

  return (
    <div data-testid={"ArticlesTab"} className="articles-tab-container">
      {drawerNature && (
        <ModalNature
          visible={drawerNature}
          initialValue={""}
          onChange={(val) => {
            const currentNature = exemptionNatures.find(el => el.id === val);
            setCurrentExemption(currentNature.nature);
            setFieldToChange({exemptionNatureId: val, exemptionNature: currentNature.nature});
          }}
          onClose={() => setDrawerNature(null)}
        />
      )}
      <div>
        <div className="precog-withholding-drawer-form—label-text"><FormattedMessage id="preCog.drawerDetail.contoSelect" /></div>
        <Select
          value={contoSelected ? contoSelected : contoId}
          style={{ width: "100%" }}
          placeholder="Seleziona conto"
          onChange={value => {
            setContoSelected(value);
            if (expandedRow.length > 0 && expandedRow[0] !== contoSelected) {
              setPage(0);
              setTimeout(() => {
                setExpandedRow([value]);
              }, 100);
            }
          }}
          getPopupContainer={(trigger) => trigger.parentNode}
        >
          {accountsList}
        </Select>
      </div>
      {accountArticles?.elements ? <>
        <div className="articles-tab-header-content">
          <Checkbox
            checked={checkedAll}
            onClick={() => {
              const newSelected = [];
              if (!accountArticles.elements) return;
              if (!checkedAll) {
                accountArticles.elements.map(el => newSelected.push(el.uuid));
              }
              setCheckedAll(!checkedAll);
              setSelectedResults(newSelected);
            }}
          />
          <div className="articles-tab-header-text"><FormattedMessage id="preCog.drawerDetail.selectAll" /></div>
        </div>
        {selectedResults?.length > 0 &&
          <ArticlesFilters
            selectedResults={selectedResults}
            contiNew={contiNew}
            contoSelected={contoSelected}
            setFieldToChange={setFieldToChange}
            isMonoRegime={isMonoRegime}
            setDrawerNature={setDrawerNature}
            currentExemption={currentExemption}
            setIsDrawerToClose={setIsDrawerToClose}
            isLoading={accountArticlesStatus?.started || patchArticleStatus}
          />}
        {(accountArticlesStatus?.started || patchArticleStatus) ? <FontAwesomeIcon
          icon={["far", "circle-notch"]}
          spin
          style={{ color: "#0090d1" }}
        /> : <div ref={containerArticlesRef} className="articles-table">
          <InfiniteScroll
            option={{
              wheelPropagation: true
            }}
            getScrollParent={() => document.querySelector(".vapor-drawer-container")}
            pageStart={0}
            loadMore={() => {
              // pagina 0 la richiamiamo in onExpand
              if (page === 0) return;
              if (accountArticles?.hasNext && !accountArticlesStatus?.started && accountArticlesStatus?.ended) {
                loadMoreItems(contoSelected);
              }
            }}
            hasMore={!accountArticlesStatus?.started && accountArticles?.hasNext}
            loader={accountArticlesStatus?.started && loader}
            useWindow={false}
          >
            {accountArticles?.elements.map((el, index) =>
              <div key={`articles-table-row_${index}`} className="articles-table-row">
                <div className="articles-table-row-zero">
                  <Checkbox
                    checked={selectedResults.indexOf(el.uuid) > -1}
                    onClick={() => {
                      const newSelected = [...selectedResults];
                      const index = selectedResults.indexOf(el.uuid);
                      if (index > -1) {
                        newSelected.splice(index, 1);
                      } else {
                        newSelected.push(el.uuid);
                      }
                      setSelectedResults(newSelected);
                    }}
                  />
                </div>
                <div className="articles-table-row-one">
                  {el.articleDesc}
                </div>
                <div className="articles-table-row-two">
                  {`${el.debit > 0 ? numeral(Math.abs(el.debit)).format("0,0.00") : numeral(Math.abs(el?.credit)).format("0,0.00")} ${refCurrency}`}
                </div>
              </div>)
            }
          </InfiniteScroll>
        </div>}
      </>
        : <div className="articles-tab-empty">
          <img src={NoArticlesImg} alt="no-articles" />
          <div className="articles-tab-empty-text"><FormattedMessage id="preCog.drawerDetail.noArticles" /></div>
        </div>}
    </div>
  );
};

export default ArticlesTab;
